export default "__VITE_ASSET__DYTMzI04__"